export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },

    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",
      user_images: data?.header?.user_images?.length ? data.header.user_images : [{ image_url: "" }],
      primary_cta: data?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: data?.header?.secondary_cta || { label: "", redirect_link: "" },
      banner_image: data?.header?.banner_image || { desktop: "", mobile: "", alt_tag: "" },
    },

    tech_section: data?.tech_section?.length ? data.tech_section : [{ title: "", description: "", alt_tag: "", desktop_image_url: "" }],

    training_level_up: {
      heading: data?.training_level_up?.heading || "",
      description: data?.training_level_up?.description || "",

      level_up_information: {
        header_one: data?.training_level_up?.level_up_information?.header_one || "",
        header_two: data?.training_level_up?.level_up_information?.header_two || "",
        header_three: data?.training_level_up?.level_up_information?.header_three || "",
        level_ups:
          data?.training_level_up?.level_up_information?.level_ups?.length > 0
            ? data.training_level_up.level_up_information.level_ups
            : [{ basis: "", before: "", after: "" }],
      },
    },

    ready_to_launch: {
      heading: data?.ready_to_launch?.heading || "",
      subheading: data?.ready_to_launch?.subheading || "",
      description: data?.ready_to_launch?.description || "",
      video_url: data?.ready_to_launch?.video_url || "",
      alt_tag:data?.ready_to_launch?.alt_tag || "",
      video_overlay_img: data?.ready_to_launch?.video_overlay_img || "",
      primary_cta: {
        label: data?.ready_to_launch?.primary_cta?.label || "",
        redirect_link: data?.ready_to_launch?.primary_cta?.redirect_link || "",
      },
    },

    testimonials: {
      heading: data?.testimonials?.heading || "",
      testimonials: data?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },

    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",
      user_images: values?.header?.user_images?.length ? values.header.user_images : [{ image_url: "" }],
      primary_cta: {
        label: values?.header?.primary_cta?.label || "",
        redirect_link: values?.header?.primary_cta?.redirect_link || "",
      },
      secondary_cta: {
        label: values?.header?.secondary_cta?.label || "",
        redirect_link: values?.header?.secondary_cta?.redirect_link || "",
      },
      banner_image: {
        desktop: values?.header?.banner_image?.desktop || "",
        mobile: values?.header?.banner_image?.mobile || "",
        alt_tag: values?.header?.banner_image?.alt_tag || "",
      },
    },
    tech_section: values?.tech_section?.length ? values.tech_section : [{ title: "", description: "", alt_tag: "", desktop_image_url: "" }],

    training_level_up: {
      heading: values?.training_level_up?.heading || "",
      description: values?.training_level_up?.description || "",

      level_up_information: {
        header_one: values?.training_level_up?.level_up_information?.header_one || "",
        header_two: values?.training_level_up?.level_up_information?.header_two || "",
        header_three: values?.training_level_up?.level_up_information?.header_three || "",
        level_ups:
          values?.training_level_up?.level_up_information?.level_ups?.length > 0
            ? values.training_level_up.level_up_information.level_ups
            : [{ basis: "", before: "", after: "" }],
      },
    },

    ready_to_launch: {
      heading: values?.ready_to_launch?.heading || "",
      subheading: values?.ready_to_launch?.subheading || "",
      description: values?.ready_to_launch?.description || "",
      video_url: values?.ready_to_launch?.video_url || "",
      alt_tag:values?.ready_to_launch?.alt_tag || "",
      video_overlay_img: values?.ready_to_launch?.video_overlay_img || "",
      primary_cta: {
        label: values?.ready_to_launch?.primary_cta?.label || "",
        redirect_link: values?.ready_to_launch?.primary_cta?.redirect_link || "",
      },
    },
    testimonials: {
      heading: values?.testimonials?.heading || "",
      testimonials: values?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};
